import { enqueueSnackbar, OptionsObject } from 'notistack';

import { logger } from '@cutwise/utils';

class NotifyAPI {
  info(message: string, options: Omit<OptionsObject, 'variant'> = {}) {
    enqueueSnackbar(message, { variant: 'info', ...options });
  }

  success(message: string, options: Omit<OptionsObject, 'variant'> = {}) {
    enqueueSnackbar(message, { variant: 'success', ...options });
  }

  error(message: Error | string, options: Omit<OptionsObject, 'variant'> = {}) {
    enqueueSnackbar(
      message instanceof Error || (message as unknown as Error)?.message ? (message as Error)?.message : message,
      {
        variant: 'error',
        ...options,
      },
    );

    logger.error(message);
  }

  warning(message: string, options: Omit<OptionsObject, 'variant'> = {}) {
    enqueueSnackbar(message, { variant: 'warning', ...options });
  }
}

export const NotifyService = new NotifyAPI();
